;$(function () {
    // since our jQuery loads async we need to copy-paste the form datepicker logic here

    // init datepicker corresponding to the language
    var config = {minDate: 0, dateFormat: 'yy-mm-dd', showAnim: 'show'};
    $('html[lang="de"] .neos-nodetypes-form-form input[type="date"]').datepicker($.extend(jQuery.datepicker.regional['de'], config));
    $('html[lang="en"] .neos-nodetypes-form-form input[type="date"]').datepicker(config);
    $('.neos-nodetypes-form-form input[type="date"]').keydown(function (e) {
        // By using "backspace" or "delete", you can clear the datepicker again.
        if (e.keyCode == 8 || e.keyCode == 46) {
            e.preventDefault();
            $.datepicker._clearDate(this);
        }
    });
});

